export interface LocalizedOption {
  value: string
  zh: string
  en: string
}

export const CASE_TYPES: LocalizedOption[] = [
  { value: 'divorce', zh: '离婚案', en: 'Divorce' },
  { value: 'contract', zh: '合同纠纷案', en: 'Contract Dispute' },
  { value: 'property', zh: '财产分割案', en: 'Property Division' },
  { value: 'debt', zh: '债务追偿案', en: 'Debt Recovery' },
  { value: 'employment', zh: '雇佣纠纷案', en: 'Employment Dispute' },
  { value: 'other', zh: '其他', en: 'Other' },
]

export const COURT_LOCATIONS: LocalizedOption[] = [
  { value: 'kuala_lumpur', zh: '吉隆坡', en: 'Kuala Lumpur' },
  { value: 'penang', zh: '槟城', en: 'Penang' },
  { value: 'johor_bahru', zh: '新山', en: 'Johor Bahru' },
  { value: 'ipoh', zh: '怡保', en: 'Ipoh' },
  { value: 'malacca', zh: '马六甲', en: 'Malacca' },
  { value: 'other', zh: '其他', en: 'Other' },
]

const CASE_TYPE_MAP = new Map(CASE_TYPES.map((c) => [c.value, c]))
const COURT_LOCATION_MAP = new Map(COURT_LOCATIONS.map((c) => [c.value, c]))

const LEGACY_CASE_TYPE_MAP = new Map<string, LocalizedOption>([
  ['离婚案', { value: '离婚案', zh: '离婚案', en: 'Divorce' }],
  ['合同纠纷', { value: '合同纠纷', zh: '合同纠纷案', en: 'Contract Dispute' }],
  ['财产分割', { value: '财产分割', zh: '财产分割案', en: 'Property Division' }],
  ['债务追偿', { value: '债务追偿', zh: '债务追偿案', en: 'Debt Recovery' }],
  ['雇佣纠纷', { value: '雇佣纠纷', zh: '雇佣纠纷案', en: 'Employment Dispute' }],
])

const LEGACY_COURT_LOCATION_MAP = new Map<string, LocalizedOption>([
  ['吉隆坡', { value: '吉隆坡', zh: '吉隆坡', en: 'Kuala Lumpur' }],
  ['槟城', { value: '槟城', zh: '槟城', en: 'Penang' }],
  ['新山', { value: '新山', zh: '新山', en: 'Johor Bahru' }],
  ['怡保', { value: '怡保', zh: '怡保', en: 'Ipoh' }],
  ['马六甲', { value: '马六甲', zh: '马六甲', en: 'Malacca' }],
])

export function translateCaseType(value: string | null | undefined, lang: 'zh' | 'en'): string {
  if (!value) return '-'
  const opt = CASE_TYPE_MAP.get(value) ?? LEGACY_CASE_TYPE_MAP.get(value)
  if (opt) return lang === 'zh' ? opt.zh : opt.en
  return value
}

export function translateCourtLocation(value: string | null | undefined, lang: 'zh' | 'en'): string {
  if (!value) return '-'
  const opt = COURT_LOCATION_MAP.get(value) ?? LEGACY_COURT_LOCATION_MAP.get(value)
  if (opt) return lang === 'zh' ? opt.zh : opt.en
  return value
}
